import { css } from '@emotion/react';
import Mixin from '../../../util/mixin';

// Horizontal dividers
//
// Dividers (basically an hr) within dropdowns and nav lists

export class NavDivider extends Mixin {
  style({$}, [
    color=undefined,
    marginY=undefined,
    // $ignoreWarning=false,
  ]) {
    color = color ?? $.navDividerColor;
    marginY = marginY ?? $.navDividerMarginY;

    return css`
      height: 0;
      margin: ${marginY} 0;
      overflow: hidden;
      border-top: 1px solid ${color};
    `;
    // @include deprecate("The `nav-divider()` mixin", "v4.4.0", "v5", $ignore-warning);
  }
}
